import ReactionComponent, { RCProps } from '../../../../ReactionComponent';
import ParticipantsV2Store from '.';

interface Props extends RCProps<ParticipantsV2Store> {}

/** Runs the search once typing pauses (pass `debounceDelay`). */
class SearchReactions extends ReactionComponent<ParticipantsV2Store, string, Props> {
  tester = () => this.props.store.searchText;
  effect = (text: string) => {
    this.props.store.search(text);
  };
}

export default SearchReactions;
